import classNames from 'classnames'
import styles from './index.module.scss'

type BackgroundHeaderArcProps = {
  showShadow: boolean
  containerStyle?: string
  aboveArcHeaderStyle?: string
  shadowArcStyle?: string
}

const BackgroundHeaderArc: React.FC<BackgroundHeaderArcProps> = ({
  showShadow,
  containerStyle,
  aboveArcHeaderStyle = '',
  shadowArcStyle = '',
}) => {
  return (
    <div className={classNames(containerStyle, styles.above_arc_container)}>
      <div
        className={classNames(styles.above_arc_header, aboveArcHeaderStyle)}
      />
      <div
        className={classNames(styles.shadow_arc, shadowArcStyle, {
          [styles['shadow_arc--show']]: showShadow,
        })}
      />
    </div>
  )
}

export default BackgroundHeaderArc
